module.exports = __webpack_public_path__ + "img/logo-conquistae.f3a53db7.svg";